import FAQ from "./components/FAQ";
import Flashcard from "./components/Flashcard";
import Navbar from "./components/Navbar";


function App() {
  return (
    <div className="App">
      <Navbar/>
      <Flashcard/>
    <FAQ/>
    </div>
  );
}

export default App;
